import React from 'react';

// helpers
import { UpdateSecurityKeyValidationSchema } from '../../../../../validations/profile/security';

// components
import InnerForm from './InnerForm';
import { Form, RequiredPropsForFormModel } from '@ui';
import { ModalDialog, RequiredPropsForModalDialogModel } from '@ui';

interface IProps
  extends RequiredPropsForModalDialogModel,
    RequiredPropsForFormModel<FormValuesModel> {
  title: string;
}

export enum RegisterSecurityKeySteps {
  Initial,
  RegisterKey,
  SetupNameForKey,
}

export interface FormValuesModel {
  name: string;
}

const SecurityKeyModal = ({
  title,
  isVisible,
  closeCallback,
  onSubmit,
  initialValues,
}: IProps) => {
  return (
    <Form
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={isVisible ? initialValues : null}
      validationSchema={UpdateSecurityKeyValidationSchema}
      renderForm={
        <ModalDialog
          width={600}
          title={title}
          isVisible={isVisible}
          closeCallback={closeCallback}
        >
          <InnerForm />
        </ModalDialog>
      }
    />
  );
};

export default SecurityKeyModal;
